import { action } from 'src/store/actions';

/* Video Topics */
export const FETCH_VIDEO_TOPICS = 'FETCH_VIDEO_TOPICS';
export const REQUEST_VIDEO_TOPICS = 'REQUEST_VIDEO_TOPICS';
export const SUCCESS_VIDEO_TOPICS = 'SUCCESS_VIDEO_TOPICS';
export const FAILURE_VIDEO_TOPICS = 'FAILURE_VIDEO_TOPICS';

export const fetchVideoTopics = () => action(FETCH_VIDEO_TOPICS);
export const requestVideoTopics = () => action(REQUEST_VIDEO_TOPICS);
export const requestVideoTopicsSuccess = (response: any) => action(SUCCESS_VIDEO_TOPICS, { response });
export const requestVideoTopicsFailure = (error: any) => action(FAILURE_VIDEO_TOPICS, { error });

/* Video Categories by topic */
export const FETCH_VIDEO_CATEGORIES = 'FETCH_VIDEO_CATEGORIES';
export const REQUEST_VIDEO_CATEGORIES = 'REQUEST_VIDEO_CATEGORIES';
export const SUCCESS_VIDEO_CATEGORIES = 'SUCCESS_VIDEO_CATEGORIES';
export const FAILURE_VIDEO_CATEGORIES = 'FAILURE_VIDEO_CATEGORIES';

export const fetchVideoCategories = (topic: string) => action(FETCH_VIDEO_CATEGORIES, { topic });
export const fetchVideoCategoriesOfTopics = (topics: string[]) => action(FETCH_VIDEO_CATEGORIES, { topics });
export const requestVideoCategories = () => action(REQUEST_VIDEO_CATEGORIES);
export const requestVideoCategoriesSuccess = (response: any) => action(SUCCESS_VIDEO_CATEGORIES, { response });
export const requestVideoCategoriesFailure = (error: any) => action(FAILURE_VIDEO_CATEGORIES, { error });

/* Video Languages */
export const FETCH_VIDEO_LANGUAGES = 'FETCH_VIDEO_LANGUAGES';
export const REQUEST_VIDEO_LANGUAGES = 'REQUEST_VIDEO_LANGUAGES';
export const SUCCESS_VIDEO_LANGUAGES = 'SUCCESS_VIDEO_LANGUAGES';
export const FAILURE_VIDEO_LANGUAGES = 'FAILURE_VIDEO_LANGUAGES';

export const fetchVideoLanguages = (topic: string) => action(FETCH_VIDEO_LANGUAGES, { topic });
export const requestVideoLanguages = () => action(REQUEST_VIDEO_LANGUAGES);
export const requestVideoLanguagesSuccess = (response: any) => action(SUCCESS_VIDEO_LANGUAGES, { response });
export const requestVideoLanguagesFailure = (error: any) => action(FAILURE_VIDEO_LANGUAGES, { error });

/* Next Video */
export const FETCH_NEXT_VIDEO = 'FETCH_NEXT_VIDEO';
export const REQUEST_NEXT_VIDEO = 'REQUEST_NEXT_VIDEO';
export const SUCCESS_NEXT_VIDEO = 'SUCCESS_NEXT_VIDEO';
export const FAILURE_NEXT_VIDEO = 'FAILURE_NEXT_VIDEO';

export const fetchNextVideo = () => action(FETCH_NEXT_VIDEO);
export const requestNextVideo = () => action(REQUEST_NEXT_VIDEO);
export const requestNextVideoSuccess = (response: any) => action(SUCCESS_NEXT_VIDEO, { response });
export const requestNextVideoFailure = (error: any) => action(FAILURE_NEXT_VIDEO, { error });
